// sharedStyles.js
export const sharedMarginStyle = {
    marginTop: "50px",
    marginLeft: "300px",
    marginRight: "300px",
    marginBottom: "50px",
};